import { WordStatusApiLoadToken, WordStatusApiService } from './services/word-status-api.service';

export const WordStatusProviders = [
  {
    provide: WordStatusApiLoadToken,
    useExisting: WordStatusApiService,
  },
];
